export default __webpack_public_path__ + "static/media/holidayon2.e0286e16.jpg";